import React, { useState, useEffect } from "react";
import AdminSidebar from "../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../component/AdminComp/AdminTopbar";
import { Download, Edit2, Trash2 } from "react-feather";
import { Spinner } from "react-bootstrap";
import * as XLSX from "xlsx";
import axios from "axios";
import { baseurl, imageUrl } from "../../Baseurl";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const AllEducationProfile = () => {
  const [profiles, setProfiles] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchEducationProfiles();
  }, []);

  const fetchEducationProfiles = async () => {
    try {
      const response = await axios.get(`${baseurl}getAllEducationProfiles`);
      setProfiles(response.data);
      setFilteredData(response.data);
    } catch (error) {
      console.error("Error fetching education profiles:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadExcel = () => {
    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "EducationProfiles");
    XLSX.writeFile(wb, "education_profiles.xlsx");
  };

  const handleEdit = (id) => {
    navigate(`/admin/edit-education/${id}`);
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This will permanently delete the profile.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios.delete(`${baseurl}deleteEducationProfileById/${id}`);
          Swal.fire("Deleted!", "The profile has been deleted.", "success");
          fetchEducationProfiles();
        } catch (error) {
          Swal.fire("Error!", "Failed to delete the profile.", "error");
        }
      }
    });
  };

  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />
      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h4 className="text-start">All Education Profiles</h4>
            <div className="d-flex align-items-center">
              <input
                type="text"
                className="form-control me-2"
                placeholder="Search by Name or About"
                onChange={(e) =>
                  setFilteredData(
                    profiles.filter((item) =>
                      `${item.name} ${item.about}`
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase())
                    )
                  )
                }
              />
              <span className="btn btnsuccess" onClick={handleDownloadExcel}>
                <Download size={17} /> &nbsp;Download
              </span>
            </div>
          </div>

          <div className="card">
            <div className="card-body" style={{ padding: 0 }}>
              {loading ? (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ height: "200px" }}
                >
                  <Spinner animation="border" role="status">
                    <span className="sr-only">Loading...</span>
                  </Spinner>
                </div>
              ) : (
                <div style={{ overflowX: "auto" }}>
                  <table className="custom-table  ">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Name</th>
                        <th>About</th>
                        <th>YouTube Link</th>
                        <th>PDF</th>
                        {/* <th>Category ID</th> */}
                        <th>Created At</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredData.length > 0 ? (
                        filteredData.map((row) => (
                          <tr key={row.id}>
                            <td>{row.id}</td>
                            <td>{row.name}</td>
                            <td>{row.about || "-"}</td>
                            <td>
                              {row.youtube_link ? (
                                <a
                                  href={row.youtube_link}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  View
                                </a>
                              ) : (
                                "-"
                              )}
                            </td>
                            <td>
                              {row.pdf_filename ? (
                                <a
                                  href={`${imageUrl}education/${row.pdf_filename}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  Download
                                </a>
                              ) : (
                                "-"
                              )}
                            </td>
                            {/* <td>{row.category_id || "-"}</td> */}
                            <td>
                              {new Date(row.created_at).toLocaleString()}
                            </td>
                            <td>
  <button
    className="btn btn-sm btn-primary me-2"
    onClick={() => handleEdit(row.id)}
  >
    <Edit2 size={14} />
  </button>
  <button
    className="btn btn-sm btn-danger"
    onClick={() => handleDelete(row.id)}
  >
    <Trash2 size={14} />
  </button>
</td>

                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="8" className="text-center">
                            No profiles found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllEducationProfile;
